import React from 'react';
import toast from 'react-hot-toast'; // Add this import
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';

const MyTasks = () => {
  const { tasks, updateTask } = useData();
  const { currentUser } = useAuth();

  const getCurrentUserId = () => {
    return currentUser?.id || currentUser?.uid;
  };

  // Filter tasks assigned to current user
  const myTasks = tasks.filter(task => {
    const userId = getCurrentUserId();
    return task.assigneeId === userId;
  });

  const handleStatusChange = async (taskId, newStatus) => {
    try {
      const task = myTasks.find(t => t.id === taskId);
      
      // Employee can only start tasks, not complete them
      if (currentUser?.role === 'employee' && newStatus === 'completed') {
        toast.error('Only project managers can mark tasks as completed');
        return;
      }
      
      await updateTask(taskId, { status: newStatus });
    } catch (error) {
      console.error('Error updating task status:', error);
    }
  };

  return (
    <div className="my-tasks">
      <div className="dashboard-header">
        <h2 className="theader-contentt">My Tasks</h2>
        <p>Tasks assigned to you ({myTasks.length})</p>
      </div>

      <div className="tasks-list">
        {myTasks.length > 0 ? (
          myTasks.map(task => (
            <div key={task.id} className="task-card-detailed">
              <div className="task-header">
                <h3>{task.title}</h3>
                <span className={`status-badge status-${task.status}`}>
                  {task.status?.replace('_', ' ')}
                </span>
              </div>
              
              <p className="projectName">{task.description}</p>
              
              <div className="task-meta">
                <span className="projectName">
                  <i className="fas fa-briefcase"></i> {task.projectName}
                </span>
                <span className="projectName">
                  <i className="fas fa-calendar"></i> Due: {new Date(task.dueDate).toLocaleDateString()}
                </span>
                <span className="projectName">
                  <i className="fas fa-clock"></i> {task.estimatedHours} hours
                </span>
                <span className="projectName">
                  <i className="fas fa-flag"></i> Priority: {task.priority}
                </span>
              </div>
              
              <div className="task-actions">
                {task.status === 'not_started' && (
                  <button 
                    onClick={() => handleStatusChange(task.id, 'ongoing')}
                    className="btn btn-primary"
                  >
                    <i className="fas fa-play"></i>
                    Start Working
                  </button>
                )}
                {task.status === 'ongoing' && currentUser?.role === 'employee' && (
                  <div className="task-info">
                    <i className="fas fa-info-circle"></i>
                    <span className="text-muted">Contact your project manager to mark as complete</span>
                  </div>
                )}
                {task.status === 'ongoing' && (currentUser?.role === 'project_manager' || currentUser?.role === 'owner') && (
                  <button 
                    onClick={() => handleStatusChange(task.id, 'completed')}
                    className="btn btn-success"
                  >
                    <i className="fas fa-check"></i>
                    Mark Complete
                  </button>
                )}
                {task.status === 'completed' && (
                  <div className="task-completed">
                    <i className="fas fa-check-circle"></i>
                    Completed
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <i className="fas fa-tasks"></i>
            <h3 >No Tasks Assigned</h3>
            <p>You don't have any tasks assigned yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyTasks;
